import type {Comment} from '../conversation-types'

/**
 * Function that determines if an automated comment has a suggestion and computes the body text to use when copying to clipboard.
 * For automated comments with suggestions, it combines the comment body with the suggestion description.
 */
export function getBodyForClipboard({comment}: {comment: Comment}): string {
  const description = comment.automatedComment?.suggestion?.description

  if (description && description !== '') {
    return `${comment.body}\n\n${description}`
  }

  return comment.body
}
